import { render, staticRenderFns } from "./OrderCardMixed.vue?vue&type=template&id=49a43001&scoped=true&"
import script from "./OrderCardMixed.vue?vue&type=script&lang=js&"
export * from "./OrderCardMixed.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardMixed.vue?vue&type=style&index=0&id=49a43001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a43001",
  null
  
)

export default component.exports